// Copies table data to the clipboard as TSV (tab-separated values).
// Excel pastes TSV directly into cells, so no Excel library is required.

// Keys that are UI-only and must not be exported.
const NON_DATA_KEYS = ['checked', 'actions'];

// Wrap a cell in double quotes when it contains a tab, newline or quote (Excel convention).
const escapeCell = value => {
  if (value === null || value === undefined) return '';
  let str = String(value);
  if (/[\t\n\r"]/.test(str)) {
    str = '"' + str.replace(/"/g, '""') + '"';
  }
  return str;
};

// Convert a plain decimal number to German notation (comma separator) so German Excel
// recognizes it as a number. Only touches clean single-number values (e.g. "342120.00"),
// leaving codes like "4.400.20", formatted currency ("1.234,56 €") or dates untouched.
const localizeDecimal = value => {
  if (typeof value === 'number' && isFinite(value)) return String(value).replace('.', ',');
  if (typeof value === 'string' && /^-?\d+\.\d+$/.test(value)) return value.replace('.', ',');
  return value;
};

// Build TSV text from BootstrapVue-style field definitions and row items.
// Applies each field's formatter so exported values match what the table shows.
const buildTsv = (fields, items) => {
  const exportFields = fields.filter(f => !NON_DATA_KEYS.includes(String(f.key).toLowerCase()));
  const header = exportFields.map(f => escapeCell(f.label != null ? f.label : f.key)).join('\t');
  const rows = (items || []).map(item =>
    exportFields
      .map(f => {
        let value = item[f.key];
        if (typeof f.formatter === 'function') value = f.formatter(value, f.key, item);
        return escapeCell(localizeDecimal(value));
      })
      .join('\t')
  );
  return [header, ...rows].join('\r\n');
};

const copyToClipboard = async text => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  // Fallback for insecure contexts / older browsers.
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
};

const copyTableToClipboard = async (fields, items) => {
  await copyToClipboard(buildTsv(fields, items));
};

module.exports = { buildTsv, copyToClipboard, copyTableToClipboard };
